import { default as _91_46_46_46slug_93Qv3uKeTLMXMeta } from "/vercel/path0/pages/[...slug].vue?macro=true";
import { default as _91companiesId_930LhNIP5mlSMeta } from "/vercel/path0/pages/companies/[companiesId].vue?macro=true";
import { default as guildlinew3pKO1r7QuMeta } from "/vercel/path0/pages/guildline.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as logint0AWlhQgM0Meta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as order_45detail1rnVrGdmNsMeta } from "/vercel/path0/pages/order-detail.vue?macro=true";
import { default as checkoutTzcETHE4EVMeta } from "/vercel/path0/pages/order/checkout.vue?macro=true";
import { default as offer8GP49abf83Meta } from "/vercel/path0/pages/order/offer.vue?macro=true";
import { default as _91salaryId_93VwwMUCe90QMeta } from "/vercel/path0/pages/salary/[salaryId].vue?macro=true";
import { default as searchBIFC2dE21WMeta } from "/vercel/path0/pages/search.vue?macro=true";
import { default as share_45my_45salaryIHyI7YFQmQMeta } from "/vercel/path0/pages/share-my-salary.vue?macro=true";
import { default as consult9n8PR4sNDLMeta } from "/vercel/path0/pages/user/consult.vue?macro=true";
import { default as credit_45historyQS3ppTyyrmMeta } from "/vercel/path0/pages/user/credit-history.vue?macro=true";
import { default as indexk3QLtbGbUrMeta } from "/vercel/path0/pages/user/index.vue?macro=true";
import { default as my_45salarywpM3MEohNFMeta } from "/vercel/path0/pages/user/my-salary.vue?macro=true";
import { default as opened_45salaryhWOOWemMKwMeta } from "/vercel/path0/pages/user/opened-salary.vue?macro=true";
import { default as ordersh1vSLUrxYHMeta } from "/vercel/path0/pages/user/orders.vue?macro=true";
import { default as subscribed_45companies5IodHcCBJVMeta } from "/vercel/path0/pages/user/subscribed-companies.vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_93Qv3uKeTLMXMeta?.name ?? "slug",
    path: _91_46_46_46slug_93Qv3uKeTLMXMeta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_93Qv3uKeTLMXMeta || {},
    alias: _91_46_46_46slug_93Qv3uKeTLMXMeta?.alias || [],
    redirect: _91_46_46_46slug_93Qv3uKeTLMXMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91companiesId_930LhNIP5mlSMeta?.name ?? "companies-companiesId",
    path: _91companiesId_930LhNIP5mlSMeta?.path ?? "/companies/:companiesId()",
    meta: _91companiesId_930LhNIP5mlSMeta || {},
    alias: _91companiesId_930LhNIP5mlSMeta?.alias || [],
    redirect: _91companiesId_930LhNIP5mlSMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/companies/[companiesId].vue").then(m => m.default || m)
  },
  {
    name: guildlinew3pKO1r7QuMeta?.name ?? "guildline",
    path: guildlinew3pKO1r7QuMeta?.path ?? "/guildline",
    meta: guildlinew3pKO1r7QuMeta || {},
    alias: guildlinew3pKO1r7QuMeta?.alias || [],
    redirect: guildlinew3pKO1r7QuMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/guildline.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index",
    path: indexe9Brt5DfdhMeta?.path ?? "/",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: logint0AWlhQgM0Meta?.name ?? "login",
    path: logint0AWlhQgM0Meta?.path ?? "/login",
    meta: logint0AWlhQgM0Meta || {},
    alias: logint0AWlhQgM0Meta?.alias || [],
    redirect: logint0AWlhQgM0Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/login.vue").then(m => m.default || m)
  },
  {
    name: order_45detail1rnVrGdmNsMeta?.name ?? "order-detail",
    path: order_45detail1rnVrGdmNsMeta?.path ?? "/order-detail",
    meta: order_45detail1rnVrGdmNsMeta || {},
    alias: order_45detail1rnVrGdmNsMeta?.alias || [],
    redirect: order_45detail1rnVrGdmNsMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/order-detail.vue").then(m => m.default || m)
  },
  {
    name: checkoutTzcETHE4EVMeta?.name ?? "order-checkout",
    path: checkoutTzcETHE4EVMeta?.path ?? "/order/checkout",
    meta: checkoutTzcETHE4EVMeta || {},
    alias: checkoutTzcETHE4EVMeta?.alias || [],
    redirect: checkoutTzcETHE4EVMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/order/checkout.vue").then(m => m.default || m)
  },
  {
    name: offer8GP49abf83Meta?.name ?? "order-offer",
    path: offer8GP49abf83Meta?.path ?? "/order/offer",
    meta: offer8GP49abf83Meta || {},
    alias: offer8GP49abf83Meta?.alias || [],
    redirect: offer8GP49abf83Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/order/offer.vue").then(m => m.default || m)
  },
  {
    name: _91salaryId_93VwwMUCe90QMeta?.name ?? "salary-salaryId",
    path: _91salaryId_93VwwMUCe90QMeta?.path ?? "/salary/:salaryId()",
    meta: _91salaryId_93VwwMUCe90QMeta || {},
    alias: _91salaryId_93VwwMUCe90QMeta?.alias || [],
    redirect: _91salaryId_93VwwMUCe90QMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/salary/[salaryId].vue").then(m => m.default || m)
  },
  {
    name: searchBIFC2dE21WMeta?.name ?? "search",
    path: searchBIFC2dE21WMeta?.path ?? "/search",
    meta: searchBIFC2dE21WMeta || {},
    alias: searchBIFC2dE21WMeta?.alias || [],
    redirect: searchBIFC2dE21WMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/search.vue").then(m => m.default || m)
  },
  {
    name: share_45my_45salaryIHyI7YFQmQMeta?.name ?? "share-my-salary",
    path: share_45my_45salaryIHyI7YFQmQMeta?.path ?? "/share-my-salary",
    meta: share_45my_45salaryIHyI7YFQmQMeta || {},
    alias: share_45my_45salaryIHyI7YFQmQMeta?.alias || [],
    redirect: share_45my_45salaryIHyI7YFQmQMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/share-my-salary.vue").then(m => m.default || m)
  },
  {
    name: consult9n8PR4sNDLMeta?.name ?? "user-consult",
    path: consult9n8PR4sNDLMeta?.path ?? "/user/consult",
    meta: consult9n8PR4sNDLMeta || {},
    alias: consult9n8PR4sNDLMeta?.alias || [],
    redirect: consult9n8PR4sNDLMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/consult.vue").then(m => m.default || m)
  },
  {
    name: credit_45historyQS3ppTyyrmMeta?.name ?? "user-credit-history",
    path: credit_45historyQS3ppTyyrmMeta?.path ?? "/user/credit-history",
    meta: credit_45historyQS3ppTyyrmMeta || {},
    alias: credit_45historyQS3ppTyyrmMeta?.alias || [],
    redirect: credit_45historyQS3ppTyyrmMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/credit-history.vue").then(m => m.default || m)
  },
  {
    name: indexk3QLtbGbUrMeta?.name ?? "user",
    path: indexk3QLtbGbUrMeta?.path ?? "/user",
    meta: indexk3QLtbGbUrMeta || {},
    alias: indexk3QLtbGbUrMeta?.alias || [],
    redirect: indexk3QLtbGbUrMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/index.vue").then(m => m.default || m)
  },
  {
    name: my_45salarywpM3MEohNFMeta?.name ?? "user-my-salary",
    path: my_45salarywpM3MEohNFMeta?.path ?? "/user/my-salary",
    meta: my_45salarywpM3MEohNFMeta || {},
    alias: my_45salarywpM3MEohNFMeta?.alias || [],
    redirect: my_45salarywpM3MEohNFMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/my-salary.vue").then(m => m.default || m)
  },
  {
    name: opened_45salaryhWOOWemMKwMeta?.name ?? "user-opened-salary",
    path: opened_45salaryhWOOWemMKwMeta?.path ?? "/user/opened-salary",
    meta: opened_45salaryhWOOWemMKwMeta || {},
    alias: opened_45salaryhWOOWemMKwMeta?.alias || [],
    redirect: opened_45salaryhWOOWemMKwMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/opened-salary.vue").then(m => m.default || m)
  },
  {
    name: ordersh1vSLUrxYHMeta?.name ?? "user-orders",
    path: ordersh1vSLUrxYHMeta?.path ?? "/user/orders",
    meta: ordersh1vSLUrxYHMeta || {},
    alias: ordersh1vSLUrxYHMeta?.alias || [],
    redirect: ordersh1vSLUrxYHMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/orders.vue").then(m => m.default || m)
  },
  {
    name: subscribed_45companies5IodHcCBJVMeta?.name ?? "user-subscribed-companies",
    path: subscribed_45companies5IodHcCBJVMeta?.path ?? "/user/subscribed-companies",
    meta: subscribed_45companies5IodHcCBJVMeta || {},
    alias: subscribed_45companies5IodHcCBJVMeta?.alias || [],
    redirect: subscribed_45companies5IodHcCBJVMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/user/subscribed-companies.vue").then(m => m.default || m)
  }
]